<template>
  <div class="mt-2">
    <div class="row justify-content-between flex-row">
      <div class="col-md-4">
        <router-link
          v-if="!hasSubmitted && permission.permissions.includes('add')"
          type="button"
          class="btn btn-info btn-sm"
          tag="button"
          to="instruction"
        >
          <small class="font-weight-bold text-truncate">{{
            $t("table-assessment.button-submit")
          }}</small>
        </router-link>
        <button
          v-else
          type="button"
          class="btn btn-secondary btn-sm"
          disabled
        >
          <small class="font-weight-bold text-truncate">{{
            $t("table-assessment.button-submit")
          }}</small>
        </button>
        <button
          v-if="!isMyDhm && isLoadingExport"
          type="button"
          class="btn btn-outline-primary btn-sm ml-2 loading-export"
        >
          <div class="spinner-border spinner-border-sm">
            <span class="sr-only">
              Loading...
            </span>
          </div>
        </button>
        <button
          v-if="!isMyDhm && !isLoadingExport"
          type="button"
          class="btn btn-outline-primary btn-sm ml-2"
          @click="exportListAssessment()"
        >
          <small class="font-weight-bold text-truncate">{{
            $t("table-assessment.button-export")
          }}</small>
        </button>
      </div>
      <div class="col-md-4 col-lg-5 d-flex my-3 my-md-0">
        <small class="px-2 text-css">{{ $t("table-assessment.show") }}</small>
        <select
          v-model="totalPage"
          class="form-control form-control-sm col-md-3 text-center"
        >
          <option
            v-for="(entries,i) in listEntries"
            :key="i"
            :value="entries"
          >
            {{ entries }}
          </option>
        </select>
      </div>
      <div class="col-md-4 col-lg-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text bg-white text-info">
              <i
                class="fa fa-search"
                aria-hidden="true"
              />
            </div>
          </div>
          <input
            v-model="search"
            type="text"
            class="form-control form-control-sm"
            @keyup.enter="searchKeyword"
          >
        </div>
      </div>
    </div>
    <div
      v-if="!listAssessment.data.length"
      class="text-center my-5 font-weight-bold"
    >
      {{ $t("table-assessment.null") }}
    </div>
    <div
      v-if="listAssessment.data.length"
      class="table-responsive mt-4"
    >
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            <th
              v-for="(list, index) in listHeader"
              :key="index"
              scope="col"
              class="pr-4"
              :class="{ 'is-pointer': sortableColumns.includes(list) }"
              @click="sortableColumns.includes(list) && $emit('sort', list)"
            >
              <small
                v-if="typeof (list) === 'object'"
                class="font-weight-bold text-nowrap"
              >
                {{ $t(list[0], [list[1]]) }}
              </small>
              <small
                v-if="typeof (list) === 'string'"
                class="font-weight-bold text-nowrap"
              >
                {{ $t(list, [index]) }}
                <span
                  v-if="sortableColumns.includes(list) && !sorts.includes(list)"
                  class="fa fa-sort"
                />
                <span
                  v-else-if="sorts === list"
                  class="fa fa-sort-up"
                />
                <span
                  v-else-if="sorts === `-${list}`"
                  class="fa fa-sort-down"
                />
              </small>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(list, index) in listAssessment.data"
            :key="index"
            :class="{'bg-danger': list.riskEng === 'high'}"
            class="border-bottom border-white"
          >
            <td class="row m-0 text-info">
              <div class="col-4">
                <i
                  v-if="permission.permissions.includes('read')"
                  class="fa fa-eye is-pointer"
                  aria-hidden="true"
                  @click="handleAction('successAssessment', true, index)"
                />
              </div>
              <div class="col-4">
                <i
                  v-if="!(todayDate !== getDate(list.createdAt) && isMyDhm) && permission.permissions.includes('edit')"
                  class="fa fa-pencil-square-o is-pointer"
                  aria-hidden="true"
                  @click="editAssessment(list.id)"
                />
              </div>
              <div class="col-4 dropdown">
                <i
                  v-if="!isMyDhm"
                  id="dropdownContact"
                  class="fa fa-ellipsis-h is-pointer"
                  aria-hidden="true"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                />
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownContact"
                >
                  <div class="d-flex">
                    <img
                      src="@/assets/icon/whatsapp.png"
                      alt="whatsapp"
                      class="mx-2 is-pointer"
                      @click="redirectContact('whatsapp', list.user.phoneNumber)"
                    >
                    <img
                      src="@/assets/icon/teams.png"
                      alt="teams"
                      class="mx-2 is-pointer"
                      @click="redirectContact('teams', list.user.email)"
                    >
                    <img
                      src="@/assets/icon/email.png"
                      alt="email"
                      class="mx-2 is-pointer"
                      @click="redirectContact('follow-up', list.user.email)"
                    >
                    <span class="is-pointer">
                      <img
                        v-if="permission.permissions.includes('add') || permission.permissions.includes('edit')"
                        src="@/assets/icon/writing-hand.png"
                        alt="follow-up"
                        class="mx-2"
                        data-toggle="modal"
                        :data-target="modalRecommendationOpen"
                        @click="handleRecommendation(list.id, list.status, list.children)"
                      >
                    </span>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-wrap">
              <small class="font-weight-normal">
                {{ dateFormat(list.createdAt) }}
              </small>
            </td>
            <td class="text-wrap">
              <small class="font-weight-normal text-capitalize">
                <template v-if="$i18n.locale === 'en'">{{ list.riskEng }}</template>
                <template v-if="$i18n.locale === 'id'">{{ list.riskIdn }}</template>
              </small>
            </td>
            <template v-if="!isMyDhm">
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.user.nric || '-' }}
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.user.fullname || '-' }}
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.user.position || '-' }}
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.user.phoneNumber || '-' }}
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.user.workUnit || '-' }}
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.user.contractor ? list.user.contractor.name : list.user.company? list.user.company.name : "-" }}
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.user.workLocationActual ? list.user.workLocationActual : '-' }}
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.user.workLocation ? list.user.workLocation.name : '-' }}
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.user.email || '-' }}
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  <template v-if="list.user.gender === true">{{ $t("table-assessment.gender.male") }}</template>
                  <template v-else-if="list.user.gender === false">{{ $t("table-assessment.gender.female") }}</template>
                  <template v-else>{{ '-' }}</template>
                </small>
              </td>
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ age(list.user.birthdate) }}/{{ birthdateFormat(list.user.birthdate) }}
                </small>
              </td>
            </template>
            <template v-if="isMyDhm">
              <td class="text-wrap">
                <small class="font-weight-normal">
                  {{ list.workLocation ? list.workLocation.name : '-' }}
                </small>
              </td>
            </template>
            <td class="text-wrap">
              <small class="font-weight-normal">
                {{ list.user.comorbid ? $t('table-assessment.comorbid.true') : $t('table-assessment.comorbid.false') }}
              </small>
            </td>
            <template v-if="!isMyDhm">
              <template v-if="list.children[0]">
                <td
                  v-for="(answerChild, i) in list.children[0].assessmentResponseAnswers"
                  :key="'A'+i"
                  class="text-wrap"
                >
                  <small
                    v-if="answerChild.answers[0]"
                    class="font-weight-normal"
                  >
                    <div
                      v-for="(theAnswer, k) in answerChild.answers"
                      :key="k"
                    >
                      <template v-if="$i18n.locale === 'en'">{{ theAnswer.titleEng }}</template>
                      <template v-if="$i18n.locale === 'id'">{{ theAnswer.titleIdn }}</template>
                    </div>
                  </small>
                  <small
                    v-else
                    class="font-weight-normal"
                  >
                    {{ answerChild.value || '-' }}
                  </small>
                </td>
              </template>
              <template v-if="!list.children[0]">
                <td
                  v-for="m in 5"
                  :key="'A' + m"
                  class="text-wrap"
                >
                  -
                </td>
              </template>
            </template>
            <td
              v-for="(answer, i) in list.assessmentResponseAnswers"
              :key="i"
              class="text-wrap"
            >
              <template v-if="answer.value">
                <small>
                  {{ answer.value }}
                </small>
              </template>
              <template v-if="!answer.value">
                <div
                  v-for="(listAnswer, j) in answer.answers"
                  :key="j"
                >
                  <small
                    v-if="$i18n.locale === 'id'"
                    class="font-weight-normal"
                  >
                    {{ listAnswer ? listAnswer.titleIdn : '-' }}
                  </small>
                  <small
                    v-if="$i18n.locale === 'en'"
                    class="font-weight-normal"
                  >
                    {{ listAnswer ? listAnswer.titleEng : '-' }}
                  </small>
                </div>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <PaginationApi
      :page-count="pagination.pageCount"
      :fetch-item="fetchListAssessment"
      :per-page="pagination.perPage"
      :current-page="pagination.currentPage"
      :next-page="pagination.nextPage"
      :prev-page="pagination.prevPage"
      :total-page="pagination.totalPage"
      :total-data="pagination.totalData"
      :visible-item="pagination.visibleAssessment"
    />
    <ViewAssessment
      v-if="modal.successAssessment"
      :id-assessment="idAssessment"
      @openModal="openModal"
    />
    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <ModalRecommendation
      v-if="modal.recommendation"
      :id-recommendation="idRecommendation"
      @closeModal="closeModal"
    />
    <ModalEditRecommendation
      v-if="modal.editRecommendation && permission.permissions.includes('edit')"
      :id-recommendation="idRecommendation"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import { PAGE_SIZES } from '@/fixtures'
import PaginationApi from './paginationApi'
import ViewAssessment from '@/components/modal/ModalViewAssessment'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import ModalRecommendation from '@/components/modal/recommendation/ModalRecommendation'
import ModalEditRecommendation from '@/components/modal/recommendation/ModalEditRecommendation'
import { format, isToday, differenceInYears } from 'date-fns'

export default {
  name: 'Tableassessment',

  components: {
    PaginationApi,
    ViewAssessment,
    ModalUnsuccessful,
    ModalRecommendation,
    ModalEditRecommendation
  },

  props: {
    permissionRecommendation: {
      type: Object,
      default: () => ({
        permissions: []
      })
    },
    permission: {
      type: Object,
      default: () => ({
        permissions: []
      })
    },
    isLoadingExport: {
      type: Boolean,
      default: () => (false)
    },
    fromEmail: {
      type: Boolean,
      default: () => (false)
    },
    idFromEmail: {
      type: String,
      default: () => ('')
    },
    listHeader: {
      type: Array,
      default: () => ([])
    },
    sortableColumns: {
      type: Array,
      default: () => ([])
    },
    sorts: {
      type: String,
      default: ''
    },
    fetchListAssessment: {
      type: Function,
      default: () => ({})
    },
    handlingSearch: {
      type: Function,
      default: () => ({})
    },
    exportListAssessment: {
      type: Function,
      default: () => ({})
    },
    pagination: {
      type: Object,
      default: () => ({
        perPage: 0,
        currentPage: 1,
        nextPage: 0,
        prevPage: 0,
        pageCount: 0,
        totalPage: 0,
        totalData: 0,
        visibleAssessment: 0
      })
    },
    listAssessment: {
      type: Object,
      default: () => ({
        totalData: 0,
        totalPage: 0,
        pageSize: 0,
        currentPage: 0,
        data: [
          {
            risk: '',
            createdAt: '',
            updatedAt: '',
            user: {
              id: '',
              fullname: '',
              username: '',
              password: '',
              email: '',
              birthdate: '',
              gender: true,
              phoneNumber: '',
              address: '',
              companyGroup: '',
              nric: '',
              comorbid: false,
              position: '',
              workUnit: '',
              company: {
                name: ''
              }
            },
            workLocation: {
              id: '',
              name: '',
              latitude: 0,
              longitude: 0,
              createdAt: '',
              updatedAt: '',
              createdBy: '',
              updatedBy: ''
            },
            assessmentResponseAnswers: [
              {
                sequence: 0,
                answers: [
                  {
                    id: '',
                    questionId: '',
                    titleIdn: '',
                    titleEng: '',
                    sequence: 0,
                    value: 0
                  }
                ]
              }
            ]
          }
        ]
      })
    },
    isMyDhm: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      user: JSON.parse(localStorage.getItem('profile')) || {},
      totalPage: 0,
      listEntries: PAGE_SIZES,
      modalRecommendationOpen: '',
      modal: {
        successAssessment: false,
        unsuccessful: false,
        recommendation: false,
        editRecommendation: false,
        textModal: ''
      },
      idAssessment: '',
      todayDate: '',
      idRecommendation: '',
      search: ''
    }
  },

  computed: {
    hasSubmitted () {
      return this.user.lastSubmissionDate && isToday(new Date(this.user.lastSubmissionDate))
    }
  },

  watch: {
    totalPage (val) {
      this.pagination.perPage = parseInt(val)
      this.pagination.currentPage = 1
      this.fetchListAssessment(this.pagination.currentPage, this.pagination.perPage)
    }
  },

  mounted () {
    if (this.fromEmail) {
      this.idAssessment = this.idFromEmail
      this.openModal('successAssessment', true)
    }
    this.todayDate = format(new Date(), 'dd-MM-yyyy')
    this.totalPage = this.pagination.perPage
    if (this.listAssessment.data.length === 0) {
      this.pagination.pageCount = 1
    } else {
      this.pagination.pageCount = Math.ceil(
        this.listAssessment.totalData / this.pagination.perPage
      )
    }
  },

  methods: {
    searchKeyword () {
      this.handlingSearch(this.search)
    },
    dateFormat (subDate) {
      return format(new Date(subDate), 'dd MMMM yyyy HH:mm')
    },
    handleAction (modalName, isOpen, index) {
      this.idAssessment = this.listAssessment.data[index].id
      this.openModal(modalName, isOpen)
    },
    openModal (modalName, isOpen) {
      this.modal[modalName] = isOpen
    },
    editAssessment (id) {
      this.$router.push({
        name: 'instruction',
        params: {
          idAssessment: id,
          edit: true
        }
      })
    },
    birthdateFormat (subDate) {
      if (subDate == null) return '-'
      return format(new Date(subDate), 'dd MMMM yyyy')
    },
    age (subDate) {
      if (subDate == null) return '-'
      return differenceInYears(new Date(), new Date(subDate))
    },
    getDate (date) {
      return format(new Date(date), 'dd-MM-yyyy')
    },
    async handleRecommendation (id, statusRecommendation, recommendation) {
      switch (statusRecommendation) {
        case 'OPEN': {
          this.modalRecommendationOpen = '#modalRecommendation'
          this.idRecommendation = id
          this.showModal('recommendation')
          break
        }
        case null: {
          this.modalRecommendationOpen = '#modalRecommendation'
          this.idRecommendation = id
          this.showModal('recommendation')
          break
        }
        default: {
          this.modalRecommendationOpen = '#modalEditRecommendation'
          this.idRecommendation = recommendation[0].id
          this.showModal('editRecommendation')
          break
        }
      }
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      if (modalname === 'recommendation') {
        this.fetchListAssessment(this.pagination.currentPage, this.pagination.perPage)
      }
    },
    redirectContact (app, contact) {
      let waPhone = 0
      if (contact) {
        switch (app) {
          case 'whatsapp': {
            if (contact[0] === '0') {
              waPhone = '+62'
              for (let i = 1; i < contact.length; i++) {
                waPhone = waPhone + contact[i]
              }
              window.open('https://wa.me/' + waPhone)
            } else if (contact[0] === '6' && contact[1] === '2') {
              waPhone = '+62'
              for (let i = 2; i < contact.length; i++) {
                waPhone = waPhone + contact[i]
              }
              window.open('https://wa.me/' + waPhone)
            } else {
              window.open('https://wa.me/' + contact)
            }
            break
          }
          case 'teams': {
            window.open('https://teams.microsoft.com/l/chat/0/0?users=', contact)
            break
          }
          case 'follow-up': {
            window.open('mailto:' + contact)
          }
        }
      } else {
        if (app === 'whatsapp') this.modal.textModal = this.$t('table-assessment.contact-err.whatsapp')
        if (app === 'teams') this.modal.textModal = this.$t('table-assessment.contact-err.teams')
        if (app === 'follow-up') this.modal.textModal = this.$t('table-assessment.contact-err.follow-up')
        this.showModal('unsuccessful')
      }
    }
  }
}
</script>

<style scoped>
.text-css {
  padding-top: 6px;
}
table td {
  width: 100px;
  word-wrap: break-word;
}
.is-pointer {
  cursor: pointer;
}
td, th {
  border: none;
}
.bg-danger {
  background-color: #FCDDDC !important;
}
.loading-export {
  width: 89px;
}
</style>
